<div class="main-container">
    <input type="file" class="file-input" [accept]="requiredFileType" (change)="onFileSelected($event)" #fileUpload />

    <div class="file-upload-container">
        <span class="file-upload-label">{{ fileName || 'Veuillez importer un fichier' }}</span>

        <button class="tv-ns-small-blue-button" (click)="fileUpload.click()">
            Importer
            <mat-icon class="material-icons-outlined">file_upload</mat-icon>
        </button>
    </div>
    <div
        class="tv-determinate-progress-bar-blue"
        id="progressBarFileUpload"
        [ngClass]="{ 'invisible-bar': (uploadProgress | async) === 0 }">
        <mat-progress-bar mode="determinate" [value]="uploadProgress | async"> </mat-progress-bar>
    </div>
</div>
